import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseReviewContactDocumentProps {
  contactId?: string
  privateCompanyLeadId?: string
  documentId?: string
  state?: string
  onSuccess: (response: AxiosResponse) => void
  onError: () => void
}

const useReviewContactDocument = ({ contactId, privateCompanyLeadId, documentId, state, onSuccess, onError }: UseReviewContactDocumentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['reviewContactDocument'],
    mutationFn: (data?: { description?: string }) => {
      const private_company_lead = {
        contacts_attributes: [
          {
            id: contactId,
            documents_attributes: [
              {
                id: documentId,
                last_review_attributes: {
                  state,
                  description: data?.description
                }
              }
            ]
          }
        ]
      }

      return privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  });
}

export default useReviewContactDocument
